import Actions from "../actions";
import { produce } from "immer";

const initialState = {
  serviceProviders: [],
  selectedServiceProviderId: "",
  selectedServiceProvider: {
    selectedServiceProviderId: "",
    navigateBack: "",
  },
  selectedOrganizationId: "",
  serviceProviderServices: {},
  serviceProviderOffers: {},
  serviceProviderPackages: {},
  staffMembersList: {}
};

const serviceProviders = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_SERVICE_PROVIDERS_LIST: {
      draft.serviceProviders = payload?.serviceProviders;
      break;
    }
    case Actions.SELECTED_SERVICE_PROVIDER_ID: {
      draft.selectedServiceProvider = payload;
      break;
    }
    case Actions.SELECTED_ORGANIZATION_ID: {
      draft.selectedOrganizationId = payload?.selectedOrganizationId;
      break;
    }
    
    case Actions.GET_SERVICE_PROVIDER_SERVICES_LIST: {
      draft.serviceProviderServices = payload?.serviceProviderServices;
      break;
    }
    case Actions.GET_SERVICE_PROVIDER_OFFERS_LIST: {
      draft.serviceProviderOffers = payload?.serviceProviderOffers;
      break;
    }

    case Actions.GET_SERVICE_PROVIDER_PACKAGES_LIST: {
      draft.serviceProviderPackages = payload?.serviceProviderPackages;
      break;
    }
    case Actions.GET_STAFF_MEMBERS_LIST_BY_SERVICE_PROVIDER_ID: {
      draft.staffMembersList = payload?.staffMembersList;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default serviceProviders;
